import React, { useEffect, useRef, useState } from 'react'
import { Checkbox, FormControlLabel, Tooltip, Typography } from '@mui/material'
import { useLeftPadding } from '../../store/redux/hooks'

type GroupOptionWithTooltipProps = {
  group: string
  selectedGroups: string[]
  handleGroupChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const GroupOptionWithTooltip = ({ group, selectedGroups, handleGroupChange }: GroupOptionWithTooltipProps) => {
  const ref = useRef<HTMLSpanElement>(null)
  const [overflowed, setOverflowed] = useState(false)
  const leftPadding = useLeftPadding()

  useEffect(() => {
    const checkOverflow = () => {
      if (ref.current) {
        setOverflowed(ref.current.scrollWidth > ref.current.clientWidth)
      }
    }
    checkOverflow()
  }, [ref])

  const getFormControl = () => {
    return (
      <FormControlLabel
        sx={{ pl: leftPadding }}
        control={<Checkbox checked={selectedGroups.includes(group)} onChange={handleGroupChange} />}
        label={
          <Typography
            ref={ref}
            sx={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
          >
            {group}
          </Typography>
        }
        value={group}
      />
    )
  }

  return overflowed ? (
    <Tooltip title={group} placement="right">
      {getFormControl()}
    </Tooltip>
  ) : (
    getFormControl()
  )
}

export default GroupOptionWithTooltip